import firebase from 'firebase'

var firebaseConfig = {
  apiKey: 'AIzaSyB1X8XsVunM6roz7y2AtoJtdxt0xwLpbeA',
  authDomain: 'codec-geo-map.firebaseapp.com',
  databaseURL: 'https://codec-geo-map.firebaseio.com',
  projectId: 'codec-geo-map',
  storageBucket: 'codec-geo-map.appspot.com',
  messagingSenderId: '866755699955',
  appId: '1:866755699955:web:c0fb5ff24125e7eb4a8386'
}
// Initialize Firebase
const fireApp = firebase.initializeApp(firebaseConfig)
export default fireApp.firestore()
